import { render, staticRenderFns } from "./TibBannerTrainInput.vue?vue&type=template&id=0e0eced6"
import script from "./TibBannerTrainInput.vue?vue&type=script&lang=js"
export * from "./TibBannerTrainInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports